import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";

const URL = "https://www.travelbackland.com/glamping-wedding-venue";
const TITLE = "Arizona Glamping Wedding Venue — Backland";
const DESC =
  "Marry under the Arizona sky at Backland — an intimate outdoor wedding venue with luxury tented lodging, on-site dining, and full-property buyouts.";
const OG_IMAGE =
  "https://www.travelbackland.com/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/path-hero.jpg";

export const Route = createFileRoute("/glamping-wedding-venue")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "EventVenue",
          name: "Backland — Arizona Glamping Wedding Venue",
          url: URL,
          description: DESC,
          address: { "@type": "PostalAddress", addressRegion: "AZ", addressCountry: "US" },
        }),
      },
    ],
  }),
  component: WeddingsRoute,
});

function WeddingsRoute() {
  return <StoryExperience initialCategorySlug="groups" />;
}
